import React, { useEffect, useState } from "react";
import { HiArrowUpRight } from "react-icons/hi2";
import api, { mediaUrl } from "../../lib/api";
import useReveal from "../../hooks/useReveal";
import useSEO from "../../seo/useSEO";
import { collectionPageSchema, breadcrumb } from "../../seo/schemas";

export default function ShopifyPortfolio() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useReveal();

  useEffect(() => {
    let live = true;
    api.get("/api/shopify")
      .then(({ data }) => { if (live) setItems(data.items || []); })
      .catch((e) => { if (live) setError(e?.response?.data?.error || e.message); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, []);

  useSEO({
    title: "Shopify Portfolio — Oguzhan Ozcelik | Shopify Expert",
    description:
      "Shopify storefronts, themes and apps built or led by Oguzhan Ozcelik — a curated portfolio of live D2C, retail and lifestyle brands.",
    path: "/shopify-portfolio",
    jsonLd: items.length ? {
      "@context": "https://schema.org",
      "@graph": [
        collectionPageSchema({
          name: "Shopify Portfolio — Oguzhan Ozcelik",
          description: "Curated Shopify storefronts, themes and apps.",
          path: "/shopify-portfolio",
          items: items.map((s) => ({ name: s.title, url: s.url, image: mediaUrl(s.image) })),
        }),
        breadcrumb([{ name: "Home", path: "/" }, { name: "Shopify Portfolio", path: "/shopify-portfolio" }]),
      ],
    } : null,
    jsonLdId: "shopify-jsonld",
  });

  return (
    <main className="shopify-page">
      <div className="container-x">
        <div className="reveal" style={{ marginBottom: 16 }}>
          <span className="eyebrow">Shopify references</span>
          <h1 className="about-hero__title" style={{ marginTop: 12 }}>
            Storefronts
            <br />
            <span className="it text-accent">that convert.</span>
          </h1>
        </div>

        <p className="lead reveal" style={{ maxWidth: "60ch", marginTop: 8 }}>
          A curated collection of Shopify stores, themes and apps I've built,
          led or contributed to — from indie D2C to Plus-grade retail.
        </p>

        <div className="featured-links reveal">
          <a className="btn" href="https://apps.shopify.com/wizy-sitemap-manager" target="_blank" rel="noreferrer noopener">
            Public Shopify App: Wizy Sitemap Manager
            <span className="arrow"><HiArrowUpRight /></span>
          </a>
        </div>

        {loading && <p className="text-muted">Loading…</p>}
        {error && <p style={{ color: "var(--danger)" }}>Failed to load: {error}</p>}
        {!loading && !error && items.length === 0 && (
          <p className="text-muted">No stores yet.</p>
        )}

        <div className="shopify-grid">
          {items.map((s) => (
            <a
              key={s.id}
              href={s.url}
              target="_blank"
              rel="noreferrer noopener"
              className="shopify-card reveal"
              title={s.title}
              aria-label={`${s.title} — open site`}
            >
              {s.image && <img src={mediaUrl(s.image)} alt={`${s.title} — Shopify storefront`} loading="lazy" />}
              <div className="shopify-card__bar">
                <div>
                  <div className="shopify-card__url">{s.title}</div>
                  <div className="text-muted" style={{ fontSize: 13 }}>
                    {(() => { try { return new URL(s.url).hostname; } catch { return s.url; } })()}
                  </div>
                </div>
                <span className="shopify-card__arrow"><HiArrowUpRight /></span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </main>
  );
}
